<div id="errorwrapper">
    <h3>Navigation Error</h3>
    <p>Unable to find a page called "<span class="highlighted">{{this.routeName}}</span>", please click <a routerLink="/home">here</a> to get back to the home page</p>
</div>
<footer></footer>
